import React from "react";
import { Link } from "react-router-dom";
import { Carousel, Card } from "react-bootstrap";
import { daysdifference } from "../helpers/helpFunction";
import { renderLocations } from "../helpers";
import Parser from "html-react-parser";
import Ribbon from "./Ribbon";

const DealCarousel = ({ images }) => {
  return (
    <Carousel
      className=""
      indicators={false}
      interval={4000}
      controls={true}
      fade={true}
    >
      {images.map(function (image, i) {
        return (
          <Carousel.Item key={i}>
            <Card className="deal-carousel">
              <Card.Img variant="top" className="p-2 img-fluid" src={image} />
            </Card>
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
};

export default DealCarousel;
